import { MapSearchContext } from 'context/MapSearchContext';
import { ZoneTileCount, ZoneTileTitle, ZoneTileWrapper } from './ZoneTile.styled';
import { useContext } from 'react';
import useMapSearch from 'hooks/search/useMapSearch';

export const ZoneTile = ({ isActive, name, onClick }: { isActive: boolean; index: number; name: string; onClick: () => void }) => {
    const { isMapSearch } = useContext(MapSearchContext);
    const { getZoneSearchCount } = useMapSearch();
    return (
        <ZoneTileWrapper onClick={onClick} isActive={isActive} data-testid="zone-tile">
            <ZoneTileTitle textVariant="body1" textAlign="center" isActive={isActive}>
                {name}
            </ZoneTileTitle>
            {isMapSearch && getZoneSearchCount(name) ? (
                <ZoneTileCount data-testid="search-count" textVariant="body1" textAlign="center" isActive={isActive}>
                    {getZoneSearchCount(name)}
                </ZoneTileCount>
            ) : null}
        </ZoneTileWrapper>
    );
};
